import type { TDensity } from '@/global/components/DataGrid/utils/types'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { TFiltrosDigitacao } from '../atoms/toolbar'

type Store = {
    organizacao: 'dia' | 'jornada'
    setOrganizar: (organizar: 'dia' | 'jornada') => void
    filtro: TFiltrosDigitacao
    setFiltro: (filtro: TFiltrosDigitacao) => void
    densidade: TDensity
    setDensidade: (densidade: TDensity) => void
}

export const useDigitacaoStore = create<Store>()(
    persist(
        set => ({
            organizacao: 'dia',
            setOrganizar: (organizar: 'dia' | 'jornada') =>
                set(store => ({
                    ...store,
                    organizacao: organizar,
                })),
            filtro: 'funcionario',
            setFiltro: (filtro: TFiltrosDigitacao) =>
                set(store => ({
                    ...store,
                    filtro,
                })),
            densidade: 'compact',
            setDensidade: (densidade: TDensity) =>
                set(store => ({
                    ...store,
                    densidade,
                })),
        }),
        {
            name: 'digitacao-store',
            version: 1,
        },
    ),
)
